import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { PaginatedNotification } from '../../models/paginated-notification.t';
import { DataTableRequest } from '../../models/datatable-request';
import { environment } from 'src/environments/environment';
import { CommonConfig } from '../../constants/common-config';
import { Observable, BehaviorSubject } from 'rxjs';
import { GeneralResponse } from 'src/app/models/general-response';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  path = '/notification';

  public unreadCount$: BehaviorSubject<number> = new BehaviorSubject<number>(0);

  constructor(private http: HttpClient) { }

  getList(payload: DataTableRequest): Observable<PaginatedNotification> {
    const params = new HttpParams()
      .append('searchTerm', payload.searchTerm)

    return this.http.get<PaginatedNotification>(
      `${environment.apiUrl}${this.path}/list/${payload.page}/${payload.dataPerPage}`,
      {
        ...CommonConfig.HTTP_OPTIONS,
        params: params,
      }
    );
  }

  getUnreadCount(): Observable<GeneralResponse> {
    return this.http.get<GeneralResponse>(
      `${environment.apiUrl}${this.path}/unread-count`,
      {
        ...CommonConfig.HTTP_OPTIONS,
      }
    );
  }

  fetchUnreadCount() {
    this.getUnreadCount().subscribe((data) => {
      if (data.count) {
        this.unreadCount$.next(data.count);
      }
    });
  }
}
